import { render, staticRenderFns } from "./DocumentationTable.vue?vue&type=template&id=dd42c8b6&scoped=true&lang=pug&"
import script from "./DocumentationTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentationTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentationTable.vue?vue&type=style&index=0&id=dd42c8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd42c8b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
